module.exports = __webpack_public_path__ + "static/apple-icon-120x120-2cee438778232c1f80c91c2785eae4c3.png";